module.exports = __webpack_public_path__ + "img/t4.4e09979d.png";